// eslint-disable-next-line import/prefer-default-export
export const SET_TEAM_ATTENDANCE_LIST = 'SET_TEAM_ATTENDANCE_LIST';
export const GET_TEAM_ATTENDANCE_LIST_PENDING =
  'GET_TEAM_ATTENDANCE_LIST_PENDING';
export const GET_TEAM_ATTENDANCE_LIST_SUCCESS =
  'GET_TEAM_ATTENDANCE_LIST_SUCCESS';
export const GET_TEAM_ATTENDANCE_LIST_ERROR = 'GET_TEAM_ATTENDANCE_LIST_ERROR';
export const GET_TEAM_ATTENDANCE_DETAILS = 'GET_TEAM_ATTENDANCE_DETAILS';
export const SET_SELECTED_TEAM_ATTENDANCE_DATE =
  'SET_SELECTED_TEAM_ATTENDANCE_DATE';
export const ADJUST_TEAM_OVERTIME_REQUEST_PENDING =
  'ADJUST_TEAM_OVERTIME_REQUEST_PENDING';
export const ADJUST_TEAM_OVERTIME_REQUEST_SUCCESS =
  'ADJUST_TEAM_OVERTIME_REQUEST_SUCCESS';
export const ADJUST_TEAM_OVERTIME_REQUEST_ERROR =
  'ADJUST_TEAM_OVERTIME_REQUEST_ERROR';

export const ADJUST_TEAM_ATTENDANCE_REQUEST_PENDING =
  'ADJUST_TEAM_ATTENDANCE_REQUEST_PENDING';
export const ADJUST_TEAM_ATTENDANCE_REQUEST_SUCCESS =
  'ADJUST_TEAM_ATTENDANCE_REQUEST_SUCCESS';
export const ADJUST_TEAM_ATTENDANCE_REQUEST_ERROR =
  'ADJUST_TEAM_ATTENDANCE_REQUEST_ERROR';
export const GET_ADJUST_TEAM_ATTENDANCE_DETAILS_SUCCESS =
  'GET_ADJUST_TEAM_ATTENDANCE_DETAILS_SUCCESS';
export const GET_ADJUST_TEAM_ATTENDANCE_DETAILS_ERROR =
  'GET_ADJUST_TEAM_ATTENDANCE_DETAILS_ERROR';
export const GET_ADJUST_TEAM_ATTENDANCE_DETAILS_PENDING =
  'GET_ADJUST_TEAM_ATTENDANCE_DETAILS_PENDING';
export const SET_ADJUST_TEAM_ATTENDANCE_DETAILS =
  'SET_ADJUST_TEAM_ATTENDANCE_DETAILS';
export const GET_ADJUST_TEAM_OVERTIME_DETAILS_SUCCESS =
  'GET_ADJUST_TEAM_OVERTIME_DETAILS_SUCCESS';
export const GET_ADJUST_TEAM_OVERTIME_DETAILS_ERROR =
  'GET_ADJUST_TEAM_OVERTIME_DETAILS_ERROR';
export const GET_ADJUST_TEAM_OVERTIME_DETAILS_PENDING =
  'GET_ADJUST_TEAM_OVERTIME_DETAILS_PENDING';
export const SET_ADJUST_TEAM_OVERTIME_DETAILS =
  'SET_ADJUST_TEAM_OVERTIME_DETAILS';
export const SET_ADJUST_TEAM_ATTENDANCE_REQUEST_INITIAL_STATE =
  'SET_ADJUST_TEAM_ATTENDANCE_REQUEST_INITIAL_STATE';
export const SET_ADJUST_TEAM_OVERTIME_REQUEST_INITIAL_STATE =
  'SET_ADJUST_TEAM_OVERTIME_REQUEST_INITIAL_STATE';
export const SET_MY_SUBORDINATE_LIST_ASYNC = 'SET_MY_SUBORDINATE_LIST_ASYNC';
export const SET_DROPDOWN_FILTER_COUNTRY = 'SET_DROPDOWN_FILTER_COUNTRY';
export const SET_DROPDOWN_FILTER_EMPLOYEE = 'SET_DROPDOWN_FILTER_EMPLOYEE';
export const CLEAR_DROPDOWN_FILTER = 'CLEAR_DROPDOWN_FILTER';
export const SET_SELECTED_SUBORDINATE_DETAILS =
  'SET_SELECTED_SUBORDINATE_DETAILS';
export const SET_TEAM_ATTENDANCE_DATE_LIST = 'SET_TEAM_ATTENDANCE_DATE_LIST';
export const SET_TEAM_ATTENDANCE_DEDUCTION_DETAILS =
  'SET_TEAM_ATTENDANCE_DEDUCTION_DETAILS';
export const GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_PENDING =
  'GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_PENDING';
export const GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_ERROR =
  'GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_ERROR';
export const GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_SUCCESS =
  'GET_TEAM_ATTENDANCE_DEDUCTION_DETAILS_SUCCESS';
export const ADJUST_TEAM_DEDUCTION_REQUEST_PENDING =
  'ADJUST_TEAM_DEDUCTION_REQUEST_PENDING';
export const ADJUST_TEAM_DEDUCTION_REQUEST_SUCCESS =
  'ADJUST_TEAM_DEDUCTION_REQUEST_SUCCESS';
export const ADJUST_TEAM_DEDUCTION_REQUEST_ERROR =
  'ADJUST_TEAM_DEDUCTION_REQUEST_ERROR';
export const SET_TEAM_DEDUCTION_REQUEST_INITIAL_STATE =
  'SET_TEAM_DEDUCTION_REQUEST_INITIAL_STATE';
export const SET_DISTINCT_SITE_LIST = 'SET_DISTINCT_SITE_LIST';
export const GET_TEAM_SUMMARY_LIST_SUCCESS = 'GET_TEAM_SUMMARY_LIST_SUCCESS';
export const GET_TEAM_SUMMARY_LIST_ERROR = 'GET_TEAM_SUMMARY_LIST_ERROR';
export const GET_TEAM_SUMMARY_LIST_PENDING = 'GET_TEAM_SUMMARY_LIST_PENDING';
export const SET_TEAM_SUMMARY_LIST = 'SET_TEAM_SUMMARY_LIST';
